<template>
  <div>
    <transition name="fade-slide">
      <div v-if="showSuccess" class="save-update-success-toast" role="status">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span>{{ showSuccessMessage }}</span>
      </div>
    </transition>
    <v-container fluid>
      <!-- Validation Dialog -->
      <v-dialog v-model="validationDialog.show" max-width="480" persistent>
        <v-card class="validation-card" elevation="4">
          <div class="validation-header">
            <span class="validation-title">{{ validationDialog.title }}</span>
            <img src="@/assets/codex_cross.svg" alt="img" width="24" height="24" @click="closeValidationDialog" style="margin-right: 4px;" />
          </div>
          <div class="validation-body">
            <p class="validation-message">{{ validationDialog.message }}</p>
          </div>
          <div>
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
          </div>
          <div class="validation-footer">
            <v-btn class="validation-ok-btn" @click="closeValidationDialog">OK</v-btn>
          </div>
        </v-card>
      </v-dialog>
      <!-- Header Section -->
      <!-- <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("_ProductDetail")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-chip
              class="date-chip"
              variant="outlined"
              prepend-icon="mdi-calendar"
            >
              
            </v-chip>
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->

      <!-- Main Content -->
      <div class="content-wrapper">
        <!-- Product Group Section -->
        <v-card class="modern-card group-card" elevation="0">
            <h3 class="card-title">Product Group Information</h3>
            <div class="mt-2">
              <hr style="border: none; border-top: 1px solid #c9c9c9;" />
            </div>
            <div class="mt-4">
              <label for="" class="mt-4">Product Group Name</label>
              <span style="color: red; margin-left: 4px;">*</span>
            </div>
            <v-text-field
              id="ProductGroupName-productdetail"
              v-model="productGroup.productGroupName"
              placeholder="Product Group Name"
              variant="plain"
              :rules="[rules.required]"
              :error-messages="
                !productGroup.productGroupName && productGroupNameTouched
                  ? 'Product Group Name is required'
                  : ''
              "
              class="minimal-field"
              hide-details
            ></v-text-field>

            <div class="products-title">
              <div class="products-header-left">
                <span class="card-title">Products</span>
                <!-- <v-chip
                  v-if="products.length > 0"
                  class="ml-3"
                  size="small"
                  color="primary"
                  variant="tonal"
                >
                  {{ products.length }}
                  {{ products.length === 1 ? "product" : "products" }}
                </v-chip> -->
              </div>

              <div class="products-header-right">
                <button class="products-header-btn" @click="openCategoryDialog"
                  :disabled="!productGroup.productGroupName"
                  :style="!productGroup.productGroupName ? 'opacity: 0.5;' : 'opacity: 1;'">
                  <img src="@/assets/material-symbols_category-outline-rounded.svg" alt="img" class="img-icon">
                  <p style="color: #001763; font-size: 14px; font-weight: 500;">Categories</p>
                </button>

                <button class="products-header-process-btn" @click="ReprocessVectorProduct"
                  :disabled="!productGroup.productGroupID || products.length === 0"
                  :style="!productGroup.productGroupName ? 'opacity: 0.5;' : 'opacity: 1;'">
                  <img src="@/assets/file-settings-line.svg" alt="img" class="img-icon" />
                  <p style="color: #FFA726; font-size: 14px; font-weight: 500;">Reprocess</p>
                  <span v-if="needsReprocessing" style="color: #FFA726; font-size: 12px;">!</span>
                  <!-- <p style="color: #FFA726; font-size: 13px;">Reprocess</p> -->
                </button>

                <div class="action-divider"></div>

                <button class="products-header-button" @click="validateBeforeAddProduct"
                  :disabled="!productGroup.productGroupName" :style="!productGroup.productGroupName ? 'opacity: 0.5;' : 'opacity: 1;'">
                  <img src="@/assets/ic_round-plus.svg" alt="img" class="img-icon">
                  <span style="color: #ffffff; font-size: 14px;">{{ $t("addProduct") }}</span>
                </button>
              </div>
            </div>
            <div class="mt-2">
              <hr style="border: none; border-top: 1px solid #c9c9c9;" />
            </div>

            <div class="products-searchCathFilter">
              <div class="filter-left">
                <!-- <button class="filter-pill" id="filterProducts-productdetail"
                  :v-model="searchCategory" 
                  :items="[
                    {
                      productCategoryName: 'All Categories',
                      productCategoryID: null,
                    },
                    ...filterCategoryOptions,
                  ]"
                  item-title="productCategoryName"
                  item-value="productCategoryID"
                  label="Filter by category"
                  variant="outlined"
                  density="comfortable"
                  @update:model-value="filterProducts"
                >
                  <img src="@/assets/mage_filter.svg" alt="filter" width="18" height="18" />
                  <span style="font-size: 13px;">Filter By Category</span>
                </button> -->
                <v-menu>
                  <template v-slot:activator="{ props }">
                    <button 
                      class="filter-pill" 
                      id="filterProducts-productdetail"
                      v-bind="props"
                    >
                      <img src="@/assets/mage_filter.svg" alt="filter" width="16" height="16" />
                      <span>
                        {{ searchCategory !== null ? getCategoryName(searchCategory) : 'Filter By Category' }}
                      </span>
                    </button>
                  </template>
                  
                  <v-card class="filter-dropdown-card" elevation="8">                    
                    <!-- Menu Items -->
                    <v-list class="filter-dropdown-list">
                      <v-list-item
                        v-for="category in [
                          { productCategoryName: 'All Categories', productCategoryID: null },
                          ...filterCategoryOptions
                        ]"
                        :key="category.productCategoryID"
                        @click="selectCategory(category.productCategoryID)"
                        :class="{ 'selected-item': searchCategory === category.productCategoryID }"
                        class="dropdown-item"
                      >
                        <v-list-item-title class="item-title">
                          {{ category.productCategoryName }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>

                <div v-if="searchProductName || searchCategory !== undefined" class="filter-info">
                  <button class="clear-filters-link" @click="clearFilters">
                    <img src="@/assets/charm_cross.svg" alt="img" width="16" height="16" />
                    <span class="filter-by">Clear Filters</span>
                  </button>
  
                  <span class="result-badge">
                    {{ filteredProducts.length }} result
                  </span>
                </div>
              </div>
              
              <div class="filter-right">
                <div class="search-wrapper">
                  <v-text-field
                    id="field-searchProductName-productdetail"
                    v-model="searchProductName"
                    placeholder="Product Name"
                    variant="plain"
                    density="comfortable"
                    clearable
                    @input="filterProducts"
                    class="pill-search"
                  >
                    <template #prepend-inner>
                      <img src="@/assets/flowbite_search-outline.svg" class="search-icon" alt="search" width="18" height="18" />
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>

            <v-card-text class="products-grid">
              <div
                v-if="filteredProducts.length === 0 && products.length === 0"
                class="empty-state"
              >
                <img src="@/assets/fluent-mdl2_product.svg" alt="img" width="38" height="38" />
                <h3 class="empty-title">No products yet</h3>
                <p class="empty-subtitle">
                  Add your first product to get started
                </p>
              </div>

              <div
                v-else-if="
                  filteredProducts.length === 0 &&
                  (searchProductName || searchCategory !== null)
                "
                class="empty-state"
              >
                <v-icon size="48" color="grey lighten-1">mdi-magnify</v-icon>
                <h3 class="empty-title">No results found</h3>
                <p class="empty-subtitle">Try adjusting your search or filters</p>
              </div>

              <div v-else class="products-list">
                <v-card
                  v-for="(product, index) in filteredProducts"
                  :key="index"
                  class="product-card-modern"
                >
                  <div class="product-layout">
                    <!-- Product Image - ลดขนาด -->
                    <div class="product-image-container">
                      <v-img
                        :src="
                          product.productImg
                            ? product.productImg
                            : '/img/no-image.png'
                        "
                        cover
                        class="product-image-modern"
                      />
                      <!-- Product Header - ปรับให้กระชับ -->
                      <div class="product-header-info">
                        <h4 class="product-name">{{ product.productName }}</h4>
                        <div class="product-price">
                          {{
                            product.productPrice
                              ? `B ${product.productPrice.toLocaleString()}`
                              : "No price"
                          }}
                        </div>
                      </div>
                    </div>

                    <!-- Product Content - ลด padding และ gap -->
                    <div class="product-content">
                      <div class="group-status-recommend-visible">
                        <div class="visible-categories">
                          <v-chip
                            size="small"
                            density="compact"
                            :color="product.isActive ? '#ffffff' : 'grey'"
                            variant="tonal"
                            class="product-status"
                          >
                            <img
                              :src="product.isActive ? iconVisible : iconHidden"
                              alt="visibility status"
                              width="20"
                              height="20"
                              style="margin-right: 8px;"
                            />
                            <p
                              style="font-size: 12px;"
                              :style="{ color: product.isActive ? '#171717' : '#C1C3CB' }"
                            >
                              {{ product.isActive ? 'Visible' : 'Hidden' }}
                            </p>
                          </v-chip>

                          <v-chip
                            size="small"
                            density="compact"
                            :color="product.productCategoryID === null ? '#ffffff' : 'grey'"
                            variant="tonal"
                            class="categories-status"
                          >
                            <img
                              :src="product.productCategoryID === null ? catIcon : catIconOff"
                              alt="category status"
                              width="16"
                              height="16"
                              style="margin-right: 8px;"
                            />
                            <p
                              style="font-size: 12px;"
                              :style="{ color: product.productCategoryID === null ? '#171717' : '#C1C3CB' }"
                            >
                              {{ getCategoryName(product.productCategoryID) }}
                            </p>
                          </v-chip>
                        </div>
                        <div>
                          <v-tooltip location="top" max-width="230px">
                            <template v-slot:activator="{ props }">
                              <img
                                v-bind="props"
                                :src="product.isRecommend ? iconRecommend : iconNotRecommend"
                                alt="img"
                                width="23"
                                height="23"
                              />
                            </template>
                            <span>Recommended Item</span>
                          </v-tooltip>
                          
                          <!-- {{ product.isRecommend ? "Rec" : "Not Rec" }} -->
                        </div>
                      </div>
                      <!-- Product Category - ลดขนาด chip -->
                      <!-- <div class="product-category">
                        <v-chip
                          size="small"
                          density="compact"
                          :color="
                            product.productCategoryID === null
                              ? 'grey'
                              : 'primary'
                          "
                          variant="tonal"
                          prepend-icon="mdi-tag"
                        >
                          {{ getCategoryName(product.productCategoryID) }}
                        </v-chip>
                      </div> -->

                      <!-- Product Status - ใช้ chip ขนาดเล็ก -->
                      <!-- <div class="product-status">
                        <v-chip
                          size="small"
                          density="compact"
                          :color="product.isRecommend ? 'success' : 'grey'"
                          variant="tonal"
                          class="status-chip"
                        >
                          <v-icon start size="12">{{
                            product.isRecommend
                              ? "mdi-thumb-up"
                              : "mdi-thumb-up-outline"
                          }}</v-icon>
                          {{ product.isRecommend ? "Rec" : "Not Rec" }}
                        </v-chip>
                        <v-chip
                          size="small"
                          density="compact"
                          :color="product.isActive ? 'info' : 'grey'"
                          variant="tonal"
                          class="status-chip"
                        >
                          <v-icon start size="12">{{
                            product.isActive ? "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                          {{ product.isActive ? "Visible" : "Hidden" }}
                        </v-chip>
                      </div> -->

                      <!-- Product Description - ลดขนาดฟอนต์และ line clamp -->
                      <p class="product-description-modern">
                        {{ product.productDetail }}
                      </p>

                      <div class="mt-4 mb-2">
                        <hr />
                      </div>

                      <!-- Product Actions - ใช้ปุ่มขนาดเล็ก -->
                      <div class="product-actions">
                        <v-tooltip location="top" max-width="230px">
                          <template v-slot:activator="{ props }">
                            <button v-bind="props" type="button" :id='"button-editproduct-productdetail"' @click="editProduct(index)">
                              <img src="@/assets/Edit.svg" alt="img" width="20" height="20" />
                            </button>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        
                        <v-tooltip location="top" max-width="230px">
                          <template v-slot:activator="{ props }">
                            <button v-bind="props" type="button" :id='"button-deleteproduct-productdetail"' @click="openDeleteDialog(product, index)" :disabled="btnDisableDelete(product)">
                              <img src="@/assets/Group.svg" alt="img" width="20" height="17" />
                            </button>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                        
                      </div>
                      <!-- <div class="product-actions">
                        <v-btn
                          :id='"button-editproduct-productdetail"'
                          variant="outlined"
                          color="primary"
                          size="small"
                          @click="editProduct(index)"
                          prepend-icon="mdi-pencil"
                          class="action-btn"
                        >
                          Edit
                        </v-btn>
                        <v-btn
                          :id='"button-deleteproduct-productdetail"'
                          variant="outlined"
                          color="error"
                          size="small"
                          @click="openDeleteDialog(product)"
                          prepend-icon="mdi-delete"
                          class="action-btn delet-btn"
                          :disabled="btnDisableDelete(product)"
                        >
                          Delete
                        </v-btn>
                      </div> -->
                    </div>
                  </div>

                  <!-- Delete Dialog -->
                  <v-dialog v-model="showDeleteDialog" max-width="570">
                    <v-card class="delete-dialog-card">
                      <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
                        <span class="dialog-title font-weight-bold">Delete Product</span>
                        <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
                          <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pt-6 pb-4 px-4 body-text">
                        Are you sure you want to delete this product ? This action cannot be undone.
                      </v-card-text>
                      <hr style="border: none; border-top: 1px solid #c9c9c9;" />
                      <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
                        <button type="button" class="cancel-btn" @click="closeDeleteDialog" :disabled="deleting">Cancel</button type="button">
                        <v-btn class="delete-confirm-btn" :loading="deleting" @click="deleteProduct()">
                          <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                          <p style="color: #ffffff; font-size: 11px; font-weight: 500;">Delete</p>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-card>
              </div>
            </v-card-text>
        </v-card>

        <!-- Products Section -->
        <!-- <v-card class="modern-card products-card mt-10" elevation="0">
          <div class="products-header">
            <div class="products-header-left">
              <v-icon class="header-icon" color="primary"
                >mdi-cube-outline</v-icon
              >
              <span class="card-title">Products</span>
              <v-chip
                v-if="products.length > 0"
                class="ml-3"
                size="small"
                color="primary"
                variant="tonal"
              >
                {{ products.length }}
                {{ products.length === 1 ? "product" : "products" }}
              </v-chip>
            </div>
            <div class="products-header-right">
              <v-btn
                id="button-reprocess-productdetail"
                class="modern-btn reprocess-btn"
                variant="elevated"
                @click="ReprocessVectorProduct"
                :disabled="
                  !productGroup.productGroupID || products.length === 0
                "
                prepend-icon="mdi-refresh"
              >
                Reprocess
                <span v-if="needsReprocessing" class="notification-badge"
                  >!</span
                >
              </v-btn>
              <v-btn
                id="ManageCategories-productdetail"
                class="modern-btn"
                color="secondary"
                variant="outlined"
                @click="openCategoryDialog"
                :disabled="!productGroup.productGroupName"
                prepend-icon="mdi-tag-multiple"
              >
                Categories
              </v-btn>
              <v-btn
                id="AddProduct-productdetail"
                class="modern-btn"
                color="primary"
                variant="elevated"
                @click="validateBeforeAddProduct"
                :disabled="!productGroup.productGroupName"
                prepend-icon="mdi-plus"
              >
                Add Product
              </v-btn>
            </div>
          </div>

          <v-card-text class="search-section">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  id="field-searchProductName-productdetail"
                  v-model="searchProductName"
                  label="Search products..."
                  variant="outlined"
                  density="comfortable"
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  @input="filterProducts"
                  class="modern-search"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  id="filterProducts-productdetail"
                  v-model="searchCategory"
                  :items="[
                    {
                      productCategoryName: 'All Categories',
                      productCategoryID: null,
                    },
                    ...filterCategoryOptions,
                  ]"
                  item-title="productCategoryName"
                  item-value="productCategoryID"
                  label="Filter by category"
                  variant="outlined"
                  density="comfortable"
                  prepend-inner-icon="mdi-filter-variant"
                  @update:model-value="filterProducts"
                  class="modern-select"
                ></v-select>
              </v-col>
            </v-row>

            <div
              v-if="searchProductName || searchCategory !== undefined"
              class="filter-info"
            >
              <v-chip
                class="result-chip"
                color="info"
                variant="tonal"
                prepend-icon="mdi-information"
              >
                {{ filteredProducts.length }} result{{
                  filteredProducts.length !== 1 ? "s" : ""
                }}
              </v-chip>
              <v-btn
                id="button-clearfilters-productdetail"
                size="small"
                variant="text"
                color="primary"
                @click="clearFilters"
                prepend-icon="mdi-filter-remove"
                class="clear-filter-btn"
              >
                Clear filters
              </v-btn>
            </div>
          </v-card-text>

          
          <v-card-text class="products-grid">
            <div
              v-if="filteredProducts.length === 0 && products.length === 0"
              class="empty-state"
            >
              <v-icon size="48" color="grey lighten-1"
                >mdi-package-variant-closed</v-icon
              >
              <h3 class="empty-title">No products yet</h3>
              <p class="empty-subtitle">
                Add your first product to get started
              </p>
            </div>
            <div
              v-else-if="
                filteredProducts.length === 0 &&
                (searchProductName || searchCategory !== null)
              "
              class="empty-state"
            >
              <v-icon size="48" color="grey lighten-1">mdi-magnify</v-icon>
              <h3 class="empty-title">No results found</h3>
              <p class="empty-subtitle">Try adjusting your search or filters</p>
            </div>
            <div v-else class="products-list">
              <v-card
                v-for="(product, index) in filteredProducts"
                :key="index"
                class="product-card-modern"
                elevation="1"
                hover
              >
                <div class="product-layout">
                  
                  <div class="product-image-container">
                    <v-img
                      :src="
                        product.productImg
                          ? product.productImg
                          : '/img/no-image.png'
                      "
                      height="120"
                      cover
                      class="product-image-modern"
                    >
                      <template v-slot:placeholder>
                        <div class="image-placeholder">
                          <v-icon size="32" color="grey lighten-2"
                            >mdi-image</v-icon
                          >
                        </div>
                      </template>
                    </v-img>
                  </div>

                 
                  <div class="product-content">
                    
                    <div class="product-header-info">
                      <h4 class="product-name">{{ product.productName }}</h4>
                      <div class="product-price">
                        {{
                          product.productPrice
                            ? `฿${product.productPrice.toLocaleString()}`
                            : "No price"
                        }}
                      </div>
                    </div>

                   
                    <div class="product-category">
                      <v-chip
                        size="small"
                        density="compact"
                        :color="
                          product.productCategoryID === null
                            ? 'grey'
                            : 'primary'
                        "
                        variant="tonal"
                        prepend-icon="mdi-tag"
                      >
                        {{ getCategoryName(product.productCategoryID) }}
                      </v-chip>
                    </div>

                    
                    <p class="product-description-modern">
                      {{ product.productDetail }}
                    </p>

                    
                    <div class="product-status">
                      <v-chip
                        size="small"
                        density="compact"
                        :color="product.isRecommend ? 'success' : 'grey'"
                        variant="tonal"
                        class="status-chip"
                      >
                        <v-icon start size="12">{{
                          product.isRecommend
                            ? "mdi-thumb-up"
                            : "mdi-thumb-up-outline"
                        }}</v-icon>
                        {{ product.isRecommend ? "Rec" : "Not Rec" }}
                      </v-chip>
                      <v-chip
                        size="small"
                        density="compact"
                        :color="product.isActive ? 'info' : 'grey'"
                        variant="tonal"
                        class="status-chip"
                      >
                        <v-icon start size="12">{{
                          product.isActive ? "mdi-eye" : "mdi-eye-off"
                        }}</v-icon>
                        {{ product.isActive ? "Visible" : "Hidden" }}
                      </v-chip>
                    </div>

                    
                    <div class="product-actions">
                      <v-btn
                        :id='"button-editproduct-productdetail"'
                        variant="outlined"
                        color="primary"
                        size="small"
                        @click="editProduct(index)"
                        prepend-icon="mdi-pencil"
                        class="action-btn"
                      >
                        Edit
                      </v-btn>
                      <v-btn
                        :id='"button-deleteproduct-productdetail"'
                        variant="outlined"
                        color="error"
                        size="small"
                        @click="deleteProduct(product.productID, index)"
                        prepend-icon="mdi-delete"
                        class="action-btn delet-btn"
                        :disabled="btnDisableDelete(product)"
                      >
                        Delete
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
          </v-card-text>
        </v-card> -->
      </div>

      <!-- Product Dialog -->
      <v-dialog v-model="productDialog" max-width="500px" class="modern-dialog">
        <v-card class="product-dialog-card" elevation="0">
          <div class="product-dialog-header">
            <h2 class="product-dialog-title">{{ editingIndex > -1 ? 'Edit Product' : 'Add New Product' }}</h2>
            <button type="button" class="product-dialog-close" @click="closeProductDialog" aria-label="Close product dialog">
              <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" />
            </button>
          </div>
          <div>
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
          </div>

          <div class="product-dialog-body">
            <div class="form-field half">
              <div class="input-container">
                <input
                  type="text"
                  id="productName-productdialog-productdetail"
                  v-model="currentProduct.productName"
                  placeholder="Product Name"
                  class="pill-input mt-4"
                />
              </div>
            </div>
            <div class="form-row mt-4 price-category-row">
              <div class="form-field price-field">
                <div class="input-with-icon">
                  <!-- Currency prefix shown only when user entered a value -->
                  <span
                    v-if="currentProduct.productPrice !== null && currentProduct.productPrice !== ''"
                    class="input-prefix"
                  >B</span>
                  <input
                    id="productprice-productdialog-productdetail"
                    v-model="currentProduct.productPrice"
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="Price"
                    @input="formatProductPrice"
                    @keydown="preventInvalidPriceInput"
                    :class="['pill-input', { 'has-prefix': currentProduct.productPrice !== null && currentProduct.productPrice !== '' }]"
                  />
                  <img src="@/assets/money-dollar-circle-line.svg" alt="currency" class="input-icon" />
                </div>
              </div>
              <div class="form-field category-field">
                <div class="category-select-wrapper">
                  <select
                    id="productCategory-productdialog-productdetail"
                    v-model="currentProduct.productCategoryID"
                    :class="['pill-select', 'category-select', currentProduct.productCategoryID !== null ? 'has-selection' : '']"
                  >
                    <!-- Placeholder / optional indicator -->
                    <option :value="null" disabled :selected="currentProduct.productCategoryID === null">
                      Category (optional)
                    </option>
                    <option
                      v-for="c in categoryOptions"
                      :key="c.productCategoryID"
                      :value="c.productCategoryID"
                    >
                      {{ c.productCategoryName }}
                    </option>
                  </select>
                  <img src="@/assets/lets-icons_arrow-drop-down.svg" alt="arrow" class="select-arrow-icon" />
                </div>
              </div>
            </div>

            <div class="mt-4">
              <div>
                <div v-if="productImage" class="upload-file-name">
                  <div class="uploaded-file">
                    <div class="product-image-preview">
                      <img :src="imagePreview" alt="Product preview" class="product-preview-img" />
                    </div>
                    <div class="uploaded-name-delete">
                      <!-- Correct Vue binding for title -->
                      <div class="file-name-rectangle" :title="productImage.name">
                        <v-tooltip location="top" open-delay="400">
                          <template #activator="{ props: nameProps }">
                            <span class="file-name-text" v-bind="nameProps">{{ productImage.name }}</span>
                          </template>
                          <span>{{ productImage.name }}</span>
                        </v-tooltip>
                      </div>
                      <img src="@/assets/facts delete.svg" alt="delete" width="24" height="24" @click="clearImage" style="cursor:pointer; margin-left: 4px;" />
                    </div>
                  </div>
                </div>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <div class="upload-box mt-4" v-bind="props" @click="$refs.fileInput.click()">
                      <input
                        id="fileInput-productdialog-productdetail"
                        ref="fileInput"
                        type="file"
                        accept="image/*"
                        style="display:none"
                        @change="handleImageUpload($event.target.files[0])"
                      />
                      <div class="upload-inner">
                        <button type="button" class="upload-btn-core">
                          <img :src="productImage ? iconFile : iconImage" alt="icon" width="16" height="16" />
                          <span style="font-size: 12px;">{{ productImage ? 'Change Image' : 'Upload File' }}</span>
                        </button>
                        <div class="mt-5" style="display: flex; align-items: center; gap: 8px;">
                          <img src="@/assets/information-line.svg" alt="img-icon" width="16" height="16" />
                          <span class="upload-hint">Support Formats : JPG, PNG, WEBP (Max 10 MB)</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <span>Supported Format : JPG, PNG, WEBP file only</span>
                </v-tooltip>
              </div>
            </div>

            <div class="checkbox-row mt-4">
              <label class="checkbox-label">
                <input type="checkbox" v-model="currentProduct.isRecommend" /> Recommend this product
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="currentProduct.isActive" /> Visible
              </label>
            </div>
            <div class="form-row mt-6">
              <textarea
                id="textarea-productdialog-productdetail"
                v-model="currentProduct.productDetail"
                rows="4"
                placeholder="Enter Product Details Here"
                class="pill-textarea"
              ></textarea>
            </div>
          </div>
          <div class="mt-6">
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
          </div>
          <!-- <div class="product-dialog-footer">
            <button type="button" class="footer-btn cancel" @click="closeProductDialog">Cancel</button>
            <button type="button" class="footer-btn save" @click="saveProduct(currentProduct)">{{ editingIndex > -1 ? 'Update' : 'Save' }}</button>
          </div> -->
          <div class="category-dialog-footer">
            <button type="button" class="footer-btn cancel" @click="closeProductDialog">Cancel</button>
            <button type="button" class="footer-btn save" @click="saveProduct(currentProduct)">
              <img src="@/assets/fluent_save-arrow-right-24-filled.png" alt="img" width="20" height="20" />
              <span>{{ editingIndex > -1 ? 'Update' : 'Save' }}</span>
            </button>
          </div>
        </v-card>
      </v-dialog>

      <!-- Category Management Dialog -->
      <v-dialog
        v-model="categoryDialog"
        max-width="700px"
        class="modern-dialog"
        @click:outside="ClickCategoryDialogOutside">
        <v-card class="category-dialog-card" elevation="0">
          <div class="category-dialog-header">
            <h2 class="category-dialog-title">Category Management</h2>
            <button type="button" class="category-dialog-close" @click="closeCategoryDialog" aria-label="Close category dialog">
              <img src="@/assets/codex_cross.svg" alt="img" width="30" height="30" />
            </button>
          </div>
          <div>
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
          </div>
          <div class="category-dialog-body">
            <p style="color: #171717; font-size: 12px; margin-top: 16px;">Add New Category</p>
            <div class="category-add-row">
              <div class="category-input-wrapper">
                <input
                  id="CategoryName-CategoryManagementDialog-productdetail"
                  v-model="newCategory"
                  @keyup.enter="addCategory"
                  type="text"
                  placeholder="Category Name"
                  class="category-input-pill"
                />
                <button
                  @click="addCategory"
                  :disabled="!newCategory || newCategory.trim()===''"
                  aria-label="Add category"
                  class="category-inline-add-btn"
                  type="button"
                >
                  <img src="@/assets/plus.svg" alt="add" width="12" height="12" />
                </button>
              </div>
            </div>
            <div class="category-list-wrapper">
              <h4 v-if="categories.length > 0" class="category-dialog-title">Current Categories</h4>
              <div v-if="categories.length===0" style="text-align: center; margin-top:170px; margin-bottom: 100px;">
                <img src="@/assets/Vector-cat.svg" alt="img" />
                <h4 class="mt-2 mb-2" style="font-weight: 400; color: #171717;">No Categories Yet</h4>
                <div style="font-weight: 400; color: #646464;">No categories yet. Use the field above to add.</div>
              </div>
              <!-- <div v-if="categories.length===0" class="category-empty mt-4">
              </div> -->
              <ul v-else class="category-ul mt-4">
                <li 
                  v-for="(category, index) in categories.filter(cat => cat.activeFlag !== false)" 
                  :key="index" 
                  class="category-li"
                >
                  <div class="category-name-wrap">
                    <input
                      v-if="editingCategoryIndex === index"
                      :id="'edit-CategoryName-CategoryManagementDialog-productdetail-' + index"
                      v-model="editedCategoryName"
                      @keyup.enter="saveEditedCategory"
                      class="category-edit-input"
                      type="text"
                      autofocus
                    />
                    <span v-else class="category-static-name">{{ category.productCategoryName }}</span>
                  </div>
                  <div class="category-row-actions">
                    <button
                      v-if="editingCategoryIndex !== index"
                      :id="'button-edit-CategoryManagementDialog-productdetail-' + index"
                      class="row-action-btn edit"
                      @click="startEditCategory(index)"
                      aria-label="Edit category"
                    >
                      <img src="@/assets/Edit.svg" alt="img" width="20" height="20" />
                    </button>
                    <button
                      v-else
                      :id="'button-confirmEdit-CategoryManagementDialog-productdetail-' + index"
                      class="row-action-btn confirm"
                      @click="saveEditedCategory"
                      aria-label="Confirm edit"
                    >
                      <img src="@/assets/Edit.svg" alt="img" width="20" height="20" style="opacity: 0.5;" />
                    </button>
                    <button
                      :id="'button-remove-CategoryManagementDialog-productdetail-' + index"
                      class="row-action-btn delete"
                      @click="removeCategory(index)"
                      aria-label="Delete category"
                    >
                      <img src="@/assets/Group.svg" alt="img" width="18" height="18" />
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="mt-12 mb-2">
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
          </div>
          <div class="category-dialog-footer">
            <button type="button" class="footer-btn cancel" @click="closeCategoryDialog">Cancel</button>
            <button type="button" class="footer-btn save" @click="saveCategory" :disabled="!isCategoryChanged">
              <img src="@/assets/fluent_save-arrow-right-24-filled.png" alt="img" width="20" height="20" />
              <span>Save</span>
            </button>
          </div>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Loading Overlay -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
// Import static assets so bundler resolves them (dynamic '@' alias strings inside ternaries won't be processed)
import iconVisible from "@/assets/gridicons_visible.svg";
import iconHidden from "@/assets/gridicons_visible-off.svg";
import catIcon from "@/assets/iconamoon_category-thin.svg";
import catIconOff from "@/assets/iconamoon_category-thin-off.svg";
import iconRecommend from "@/assets/recommend.svg";
import iconNotRecommend from "@/assets/recommend-off.png";
import iconImage from "@/assets/upload-cloud-2-line.svg";
import iconFile from "@/assets/mdi_image-edit-outline.svg";
export default {
  name: "ProductDetail",
  mixins: [checkPermissionTwo],
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround","Username" , "RoleId"],
  data: () => ({
    showDeleteDialog: false,
    deleting: false,
    showSuccess: false,
    showSuccessMessage: "",
    // Expose imported icon assets for template bindings
    iconVisible,
    iconHidden,
    catIcon,
    catIconOff,
    iconRecommend,
    iconNotRecommend,
    iconImage,
    iconFile,
    id: null,
    today: null,
    uploadedFiles: [],
    entity: null,
    dialog: false,
    searchProductName: "",
    searchCategory: null,
    filteredProductsList: [],
    productGroup: {
      productGroupID: null,
      productGroupName: "",
    },

    // Categories
    newCategory: "",
    categories: [],
    nextCategoryId: 1,
    originalCategories: [], // เก็บ categories ต้นฉบับไว้เปรียบเทียบ

    // Products
    products: [],
    currentProduct: {
      productID: 0,
      productGroupID: 0,
      productCategoryID: null,
      productName: "",
      productImg: "",
      productDetail: "",
      productPrice: null,
      isRecommend: false,
      isActive: true,
    },
    nextProductId: 1,
    productDialog: false,
    editingIndex: -1,
    deleteIndex: -1,

    // Image handling
    productImage: null,
    imagePreview: null,

    // Validation
    rules: {
      required: (value) => !!value || "Required field",
      positiveNumber: (value) =>
        value === null ||
        value === "" ||
        parseFloat(value) >= 0 ||
        "Price must be positive",
      maxTwoDecimals: (value) => {
        if (value === null || value === "") return true;
        const regex = /^\d+(\.\d{0,2})?$/;
        return (
          regex.test(value.toString()) || "Maximum 2 decimal places allowed"
        );
      },
    },
    // Add this property to your existing data
    categoryDialog: false,

    // Add isSaving to track save state
    productGroupNameTouched: false,

    // Add these properties to your existing data
    editingCategoryIndex: -1,
    editedCategoryName: "",

    needsReprocessing: false,
  validationDialog: { show: false, title: '', message: '' },
  }),
  computed: {
    filteredProducts() {
      return this.searchProductName || this.searchCategory !== null
        ? this.filteredProductsList
        : this.products;
    },
    isProductFormValid() {
      return this.currentProduct.productName;
    },
    filterCategoryOptions() {
      let self = this;
      return [
        ...self.categories.map((cat) => ({
          productCategoryName: cat.productCategoryName,
          productCategoryID: cat.productCategoryID,
          activeFlag: cat.activeFlag,
        })),
      ];
    },
    categoryOptions() {
      let self = this;
      return [
        {
          productCategoryName: "No Category",
          productCategoryID: 0,
          activeFlag: true,
        },
        ...self.categories.map((cat) => ({
          productCategoryName: cat.productCategoryName,
          productCategoryID: cat.productCategoryID,
          activeFlag: cat.activeFlag,
        })),
      ];
    },
    isCategoryChanged() {
      // Check if lengths differ (new categories added or removed)
    const currentActive = this.categories.filter(cat => cat.activeFlag !== false);
    const originalActive = this.originalCategories.filter(cat => cat.activeFlag !== false);
    
    if (currentActive.length !== originalActive.length) {
      return true;
    }

    // Check if any category has been marked as inactive (deleted)
    for (let i = 0; i < this.categories.length; i++) {
      const current = this.categories[i];
      const original = this.originalCategories.find(
        (cat) => cat.productCategoryID === current.productCategoryID
      );

      // If a category was marked as inactive, that's a change
      if (original && current.activeFlag === false && original.activeFlag !== false) {
        return true;
      }

      // If activeFlag changed from false to true (re-activated)
      if (original && current.activeFlag !== false && original.activeFlag === false) {
        return true;
      }
    }

    // Check if any category name has been changed
    for (let i = 0; i < currentActive.length; i++) {
      const current = currentActive[i];
      const original = originalActive.find(
        (cat) => cat.productCategoryID === current.productCategoryID
      );

      // If category not found or name changed, mark as changed
      if (
        !original ||
        current.productCategoryName !== original.productCategoryName
      ) {
        return true;
      }
    }

    return false;
  },
  },
  watch: {},
  methods: {
    btnDisableDelete(item) {
      if (this.RoleId == 2 && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    ClickCategoryDialogOutside() {
      this.newCategory = "";
      this.categories = this.categories.filter(item => item.productCategoryID !== null);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    selectCategory(categoryId) {
      this.searchCategory = categoryId;
      this.filterProducts();
    },
    
    getCategoryName(categoryId) {
      if (categoryId === null) {
        return "All Categories";
      }
      const category = this.filterCategoryOptions.find(
        (cat) => cat.productCategoryID === categoryId
      );
      return category ? category.productCategoryName : "All Categories";
    },
    validateBeforeAddProduct() {
      if (
        !this.productGroup.productGroupName ||
        this.productGroup.productGroupName.trim() === ""
      ) {
        this.$swal.fire({
          icon: "warning",
          title: "Product Group Name Required",
          text: "Please enter a Product Group Name before adding products.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      // If validation passes, open the product dialog
      this.openProductDialog();
    },
    // Category methods
    addCategory() {
      // ตรวจสอบว่ามีข้อความหรือไม่
      if (!this.newCategory || this.newCategory.trim() === "") return;

      // ตรวจสอบว่ามีชื่อซ้ำกันหรือไม่ (ไม่คำนึงถึงตัวพิมพ์ใหญ่-เล็ก)
      const categoryNameLower = this.newCategory.trim().toLowerCase();
      const isDuplicate = this.categories.some(
        (cat) => cat.productCategoryName.toLowerCase() === categoryNameLower
      );

      // ถ้ามีชื่อซ้ำ ให้แสดง alert และไม่เพิ่มข้อมูล
      if (isDuplicate) {
        this.$swal.fire({
          icon: "warning",
          title: "Duplicate Category",
          text: `Category "${this.newCategory}" already exists.`,
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      // ถ้าไม่ซ้ำ ค่อยเพิ่มข้อมูล
      this.categories.push({
        productCategoryID: null,
        productCategoryName: this.newCategory.trim(),
        activeFlag: true,
      });

      this.newCategory = "";

      // If a search filter is active, update results
      if (this.searchProductName || this.searchCategory !== null) {
        this.filterProducts();
      }
    },

    removeCategory(index) {
      const category = this.categories[index];
      const categoryId = category.productCategoryID;
      
      // Check if category is in use before removing
      const inUse = this.products.some(
        (product) => product.productCategoryID === categoryId
      );

      if (inUse) {
        this.$swal.fire({
          icon: "warning",
          title: "Cannot Remove Category",
          text: "This category is being used by one or more products.",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        });
        return;
      }

      // If the category exists in database (has productCategoryID), mark as inactive
      if (categoryId !== null && categoryId !== undefined) {
        this.categories[index].activeFlag = false;
      } else {
        // If it's a new category (no productCategoryID yet), remove from array
        this.categories.splice(index, 1);
      }
    },

    getCategoryName(categoryId) {
      if (categoryId === null) {
        return "No Category";
      }
      const category = this.categories.find(
        (cat) => cat.productCategoryID === categoryId
      );
      return category ? category.productCategoryName : "No Category";
    },

    // Add these methods to your existing methods
    startEditCategory(index) {
      this.editingCategoryIndex = index;
      this.editedCategoryName = this.categories[index].productCategoryName;
    },

    // แก้ไขเมธอด saveEditedCategory() ให้ทำงานเมื่อกดปุ่มยืนยัน และตรวจสอบชื่อซ้ำ
    saveEditedCategory() {
      if (this.editingCategoryIndex === -1) return;

      // ตรวจสอบว่าชื่อไม่ว่างเปล่า
      if (!this.editedCategoryName || this.editedCategoryName.trim() === "") {
        this.$swal.fire({
          icon: "warning",
          title: "Category Name Required",
          text: "Category name cannot be empty.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      // ตรวจสอบการซ้ำกันของชื่อ category (ไม่รวมตัวเอง)
      const categoryNameLower = this.editedCategoryName.trim().toLowerCase();
      const isDuplicate = this.categories.some(
        (cat, idx) =>
          idx !== this.editingCategoryIndex &&
          cat.productCategoryName.toLowerCase() === categoryNameLower
      );

      if (isDuplicate) {
        this.$swal.fire({
          icon: "warning",
          title: "Duplicate Category",
          text: `Category "${this.editedCategoryName}" already exists.`,
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      // บันทึกการเปลี่ยนแปลง
      this.categories[this.editingCategoryIndex].productCategoryName =
        this.editedCategoryName.trim();

      // ออกจากโหมดแก้ไข
      this.editingCategoryIndex = -1;
      this.editedCategoryName = "";

      // ถ้ามีการใช้ filter อยู่ ให้อัปเดตผลลัพธ์
      if (this.searchProductName || this.searchCategory !== null) {
        this.filterProducts();
      }
    },

    cancelEditCategory() {
      this.editingCategoryIndex = -1;
      this.editedCategoryName = "";
    },

    // Product methods
    openProductDialog() {
      this.editingIndex = -1;
      this.currentProduct = {
        productID: 0,
        productGroupID: this.productGroup.productGroupID,
        productCategoryID:
          this.categories.length > 0
            ? this.categories[0].productCategoryID
            : null,
        productName: "",
        productImg: "",
        productDetail: "",
        productPrice: null,
        isRecommend: false,
        isActive: true,
      };
      this.imagePreview = null;
      this.productImage = null;
      this.productDialog = true;
    },

    editProduct(index) {
      let filterProductsTemp =
        this.filteredProductsList.length == 0
          ? this.products
          : this.filteredProductsList;
      this.editingIndex = index;
      this.currentProduct = { ...filterProductsTemp[index] };
      this.imagePreview = filterProductsTemp[index].productImg;
      this.productDialog = true;
    },

    closeProductDialog() {
      this.productDialog = false;
    },
    filterProducts() {
      // Apply filters only if at least one filter is set
      const hasProductNameFilter =
        this.searchProductName && this.searchProductName.trim() !== "";
      const hasCategoryFilter =
        this.searchCategory !== null && this.searchCategory !== undefined;

      if (!hasProductNameFilter && !hasCategoryFilter) {
        this.filteredProductsList = [];
        return;
      }

      this.filteredProductsList = this.products.filter((product) => {
        let matchesProductName = true;
        let matchesCategory = true;

        // Apply product name filter if set
        if (hasProductNameFilter) {
          const productNameLower = product.productName.toLowerCase();
          const searchTermLower = this.searchProductName.toLowerCase();
          matchesProductName = productNameLower.includes(searchTermLower);
        }

        // Apply category filter if set
        if (hasCategoryFilter) {
          matchesCategory = product.productCategoryID === this.searchCategory;
        }

        // Return true only if all applied filters match
        return matchesProductName && matchesCategory;
      });
    },

    // Add a method to clear all filters
    clearFilters() {
      this.searchProductName = "";
      this.searchCategory = null;
      this.filteredProductsList = [];
    },
    openDeleteDialog(product, index) {
      this.itemToDelete = product;
      this.showDeleteDialog = true;
      this.deleteIndex = index;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.itemToDelete = null;
    },
    deleteProduct() {
      const self = this;
      let id = self.itemToDelete.productID;
      this.showDeleteDialog = false;
      this.deleting = true;
      this.dialog = true;
      try {
        self.$call.DeleteProduct(
          {
            ProductID: id,
            ProductGroupID: self.productGroup.productGroupID,
          },
          (dataResponse) => {
            if (dataResponse.status === 0) {
              if (self.deleteIndex > -1) {
                const prodIdx = self.products.findIndex(p => p.productID === id);
                if (prodIdx > -1) {
                  self.products.splice(prodIdx, 1);
                }
                self.deleteIndex = -1;
                self.showToast("Product has been deleted !");
                if (self.searchProductName || self.searchCategory !== null) {
                  self.filterProducts();
                }
              }
            }else if (dataResponse.status == 1) {
              self.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: true,
                confirmButtonText: this.$t("gotIt"),
                confirmButtonColor: "#d33",
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    ReprocessVectorProduct() {
      let self = this;
      try {
        self.$swal
          .fire({
            title: "Reprocess Product",
            text: "Are you sure you want to reprocess this product group? This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.ReprocessVectorProduct(
                { ProductGroupID: self.productGroup.productGroupID },
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.showToast("Product reprocess successfully");
                    self.needsReprocessing = false;
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    // Image handling
    clearImage() {
      this.productImage = null;
      this.imagePreview = null;
      this.currentProduct.productImg = "";
      // Reset the file input element value so the same file can be selected again
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
    },
    handleImageUpload(file) {
      // Force clear previous image data first
      this.imagePreview = null;
      this.currentProduct.productImg = "";

      if (!file) {
        this.productImage = null;
        return;
      }

      // In a real application, you would upload this to your server
      // Here we just create a temporary URL for preview
      this.imagePreview = URL.createObjectURL(file);
      this.currentProduct.productImg = this.imagePreview;
      this.productImage = file;

      // In production, you would set productImg to the URL returned by your upload API
    },

    showToast(message, duration = 3000) {
      this.showSuccessMessage = message;
      this.showSuccess = true;
      if (this._toastTimer) {
        clearTimeout(this._toastTimer);
      }
      this._toastTimer = setTimeout(() => {
        this.showSuccess = false;
      }, duration);
    },
    getProductGroupData() {
      var self = this;
      self.dialog = true;
      this.$call.GetProductDetailById(
        this.id,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.productGroup = {
              productGroupID: dataResponse.data.productGroupID,
              productGroupName: dataResponse.data.productGroupName,
            };
            self.categories = dataResponse.data.productCategories.filter(
              cat => cat.activeFlag !== false
            );
            self.products = dataResponse.data.products;
            self.needsReprocessing = dataResponse.data.needsReprocessing;
          }
          self.dialog = false;
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    // Save product
    saveProduct(product) {
      const self = this;
      if (
        !this.productGroup.productGroupName ||
        this.productGroup.productGroupName.trim() === ""
      ) {
        this.productGroupNameTouched = true;
        this.openValidationDialog(
          "Product Group Name Required",
          "Please enter a product group name before saving."
        );
        return;
      }
      if (!product.productName || product.productName.trim() === "") {
        this.openValidationDialog(
          "Product Name Required",
          "Please enter a product name before saving."
        );
        return;
      }
      if (!product.productDetail || product.productDetail.trim() === "") {
        this.openValidationDialog(
          "Product Detail Required",
          "Please enter a product detail before saving."
        );
        return;
      }
      // สร้าง FormData สำหรับส่งไฟล์และข้อมูล
      const formData = new FormData();

      // เพิ่มไฟล์รูปภาพ (ถ้ามี)
      if (this.productImage) {
        formData.append("productImage", this.productImage);
      }

      const payload = {
        productGroupID: this.productGroup.productGroupID,
        productGroupName: this.productGroup.productGroupName,
        productID: product.productID || null,
        productCategoryID: product.productCategoryID || 0,
        productName: product.productName,
        productDetail: product.productDetail || "",
        productPrice: product.productPrice || 0,
        productImg: product.productImg,
        isRecommend: product.isRecommend,
        isActive: product.isActive,
        activeFlag: true,
      };

      // แปลง object เป็น JSON และเพิ่มลงใน FormData
      formData.append("productData", JSON.stringify(payload));
      this.dialog = true;
      this.$call.CreateProduct(
        formData,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.productGroup.productGroupID = dataResponse.data.productGroupID;
            self.products = dataResponse.data.product;

            // Update URL with the product group ID if it's a new product group
            if (self.id === null || self.id === undefined) {
              // Update browser URL without reloading the page
              const newUrl = `${window.location.pathname}?id=${self.productGroup.productGroupID}`;
              history.pushState({ path: newUrl }, "", newUrl);

              // Update the component's id property
              self.id = self.productGroup.productGroupID;
            }

            this.closeProductDialog();
            this.showToast(
              this.editingIndex === -1
                ? "Product Added Successfully"
                : "Product Updated Successfully"
            );

            // After save, reapply filters if any are active
            if (this.searchProductName || this.searchCategory !== null) {
              this.filterProducts();
            }
          }else if (dataResponse.status === 3) {
            this.categories = this.categories.filter(
                (item) => item.productCategoryID !== null
              );
            self.$swal.fire({
              icon: "warning",
              title:dataResponse.message,
              // title: "Duplicate Product",
              // text: dataResponse.message,
              confirmButtonColor: "#3085d6",
            });
          }
          self.dialog = false;
          self.clearImage();
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    openValidationDialog(title, message) {
      this.validationDialog.title = title;
      this.validationDialog.message = message;
      this.validationDialog.show = true;
    },
    closeValidationDialog() {
      this.validationDialog.show = false;
    },

    // Save category
    saveCategory() {
      const self = this;
      
      // First validate the product group name
      if (
        !self.productGroup.productGroupName ||
        self.productGroup.productGroupName.trim() === ""
      ) {
        self.productGroupNameTouched = true;
        self.$swal.fire({
          icon: "warning",
          title: "Product Group Name Required",
          text: "Please enter a Product Group Name before saving.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      const payload = {
        productGroupID: self.productGroup.productGroupID,
        productGroupName: self.productGroup.productGroupName,
        // Send ALL categories including those marked for deletion
        categories: self.categories.map(cat => ({
          productCategoryID: cat.productCategoryID,
          productCategoryName: cat.productCategoryName,
          activeFlag: cat.activeFlag !== undefined ? cat.activeFlag : true
        }))
      };

      self.dialog = true;

      self.$call.CreateCategory(
        payload,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.productGroup.productGroupID = dataResponse.data.productGroupID;
            
            // Update categories and filter out inactive ones for display
            self.categories = dataResponse.data.categories.filter(cat => cat.activeFlag !== false);

            // Update URL with the product group ID if it's a new product group
            if (self.id === null || self.id === undefined) {
              const newUrl = `${window.location.pathname}?id=${self.productGroup.productGroupID}`;
              history.pushState({ path: newUrl }, "", newUrl);
              self.id = self.productGroup.productGroupID;
            }

            self.showToast("Categories saved successfully");
          } else if (dataResponse.status === 3) {
            self.categories = self.categories.filter(
              (item) => item.productCategoryID !== null
            );
            self.$swal.fire({
              icon: "warning",
              title: dataResponse.message,
              confirmButtonColor: "#3085d6",
            });
          }
          self.categoryDialog = false;
          self.newCategory = "";
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    // Add these methods to your existing methods
    openCategoryDialog() {
      // เก็บสำเนาของ categories ไว้เปรียบเทียบการเปลี่ยนแปลง
      this.originalCategories = JSON.parse(JSON.stringify(
      this.categories.map(cat => ({
        productCategoryID: cat.productCategoryID,
        productCategoryName: cat.productCategoryName,
        activeFlag: cat.activeFlag !== undefined ? cat.activeFlag : true
      }))
    ));
    this.categoryDialog = true;
    },

    closeCategoryDialog() {
      if (this.isCategoryChanged) {
        this.$swal
          .fire({
            title: "Unsaved Changes",
            text: "You have unsaved changes. Are you sure you want to close without saving?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, close",
            cancelButtonText: "No, keep editing",
            confirmButtonColor: "#3085d6",
          })
          .then((result) => {
            if (result.isConfirmed) {
              // Restore to original state with proper deep copy
              this.categories = JSON.parse(JSON.stringify(this.originalCategories));
              this.categoryDialog = false;
              this.editingCategoryIndex = -1;
              this.editedCategoryName = "";
              this.newCategory = "";
            }
          });
      } else {
        this.categoryDialog = false;
        this.editingCategoryIndex = -1;
        this.editedCategoryName = "";
        this.newCategory = "";
      }
    },
    formatProductPrice() {
      // Allow empty value
      if (
        this.currentProduct.productPrice === null ||
        this.currentProduct.productPrice === ""
      ) {
        return;
      }

      // Convert to string and validate format
      let priceStr = this.currentProduct.productPrice.toString();

      // Ensure positive number - should no longer be needed due to keydown prevention
      // but keeping as a safeguard
      if (parseFloat(priceStr) < 0) {
        this.currentProduct.productPrice = 0;
        return;
      }

      // If more than 2 decimal places, truncate to 2
      if (priceStr.includes(".")) {
        const parts = priceStr.split(".");
        if (parts[1] && parts[1].length > 2) {
          // Truncate to 2 decimal places
          this.currentProduct.productPrice = parseFloat(
            parts[0] + "." + parts[1].substring(0, 2)
          );
        }
      }
    },
    preventInvalidPriceInput(e) {
      // Prevent minus sign
      if (e.key === "-") {
        e.preventDefault();
        return;
      }

      // Prevent more than 2 decimal places
      if (
        e.key !== "Backspace" &&
        e.key !== "Delete" &&
        e.key !== "Tab" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight"
      ) {
        const value = e.target.value;
        if (value.includes(".")) {
          const parts = value.split(".");
          if (parts[1] && parts[1].length > 1) {
            // Get cursor position
            e.preventDefault();
            return;
          }
        }
      }
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    if (self.$route.query.id) {
      self.id = this.$route.query.id;
      this.getProductGroupData(self.id);
    } else {
      // Initialize as a new product group
      self.id = null;
      self.productGroup = {
        productGroupID: null,
        productGroupName: "",
      };
      self.categories = [];
      self.products = [];
    }
  },
};
</script>
<style scoped>
.input-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

/* Base input styling */
.pill-input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 20px;
  border: 1px solid #c9c9c9;
  color: #171717;
  font-size: 14px;
}

/* Add red * right after placeholder text */
.input-container::after {
  content: " *";
  position: absolute;
  left: 120px;
  top: 41%;
  color: red;
  pointer-events: none;
  font-size: 16px;
}

/* Hide the star when input has value */
.input-container:has(.pill-input:not(:placeholder-shown))::after {
  content: "";
}

/* Delete dialog specific styling */
.delete-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #C30000;
}
.body-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: #171717;
}
.cancel-btn {
  border: 1px solid #949AA8;
  border-radius: 12px;
  height: 40px;
  padding: 4px 16px;
}
.delete-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  width: 120px;
  background-color: #C30000;
}
.fade-slide-enter-active, .fade-slide-leave-active { transition: all .35s ease; }
.fade-slide-enter-from, .fade-slide-leave-to { opacity:0; transform: translate(-50%, -8px); }
.fade-slide-enter-to, .fade-slide-leave-from { opacity:1; transform: translate(-50%, 0); }
.save-update-success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg,#2ABF56,#135928);
  color: #ffffff;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 80px;
}
.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0 9px;
  margin-top: -6px;
}

/* Header Section */
.modern-header {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-icon {
  color: rgba(0, 0, 0, 0.753) !important;
}

.date-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* Modern Cards */
.modern-card {
  padding: 1.5rem;
  background: #ffffff;
  border-radius: 16px !important;
  border: 1px solid #DCDCDC;
  box-shadow: none;
}

/* .modern-card:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
} */

.products-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

/* Card Headers */
.card-header,
.products-header {
  display: flex;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-radius: 16px 16px 0 0;
}

.products-header {
  justify-content: space-between;
}

.products-header-left,
.products-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.products-header-btn {
  display: flex;
  flex-direction: row;
  gap: 4px;
  padding: 8px;
}

.products-header-btn:hover {
  border-radius: 10px;
  background: rgba(0, 23, 99, 0.1);
}

.products-header-process-btn {
  display: flex;
  flex-direction: row;
  gap: 4px;
  padding: 8px;
}

.products-header-process-btn:hover {
  border-radius: 10px;
  background: rgba(255, 167, 38, 0.1) !important;
}

.action-divider {
  width: 1px;
  height: 34px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
  /* margin-left: -16px; */
}

.img-icon {
  width: 20px;
  height: 20px;
}

.products-header-button {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 140px;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 6px;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #171717;
}

.card-content {
  padding: 2rem;
}
/* Minimal Input Styles */
.minimal-field {
  margin-bottom: 8px;
  width: 50%;
  margin-top: 4px;
  color: #171717;
}

/* Core pill styling for plain variant */
.minimal-field :deep(.v-field) {
  background: #ffffff !important;
  border: 1px solid #c9c9c9 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
  min-height: 40px !important;
  padding-inline: 2px !important;
  transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;
}
/* .minimal-field :deep(.v-field--focused) {
  border: 1px solid #1976d2 !important;
  box-shadow: 0 0 0 2px rgba(25,118,210,0.18) !important;
  background: #ffffff !important;
}
.minimal-field :deep(.v-field--error) {
  border: 1px solid #f44336 !important;
  box-shadow: 0 0 0 2px rgba(244,67,54,0.18) !important;
} */
.minimal-field :deep(.v-field__outline) { display: none !important; }
.minimal-field :deep(.v-label) { display: none !important; }
.minimal-field :deep(.v-field__input) {
  padding: 0px 10px !important;
  font-size: 14px !important;
  line-height: 10px !important;
  height: 100% !important;
}
.minimal-field :deep(input::placeholder) {
  color: #cccccc !important;
  opacity: 0.85 !important;
  font-size: 13px !important;
}
.minimal-field :deep(.v-field__append-inner),
.minimal-field :deep(.v-field__prepend-inner) {
  padding-inline: 4px !important;
}
.minimal-field :deep(.v-messages) { display: none !important; }
.minimal-field :deep(.v-field--disabled) {
  background: #f5f5f5 !important;
  border-color: #e0e0e0 !important;
  color: #9e9e9e !important;
}

.products-searchCathFilter {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  align-items: center;
}

.filter-left,
.filter-right { 
  display: flex; 
  align-items: center; 
  gap: 6px;
}

.filter-pill { 
  display: flex;
  align-items: center;
  gap: 6px; 
  background: #ffffff; 
  border: 1px solid #c9c9c9;
  border-radius: 10px; 
  padding: 6px;
  color: #171717;
  cursor: pointer; 
}
/* Dropdown Card */
.filter-dropdown-card {
  border-radius: 16px !important;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  min-width: 200px;
  max-width: 280px;
}

/* Dropdown Header */
.dropdown-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.dropdown-title {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  letter-spacing: 0.5px;
}

/* List Styling */
.filter-dropdown-list {
  padding: 8px 0 !important;
  background: #ffffff;
}

/* List Items */
.dropdown-item {
  padding: 12px 16px !important;
  min-height: 44px !important;
  transition: all 0.15s ease !important;
  cursor: pointer;
  border-radius: 0 !important;
}

.dropdown-item:hover {
  background: #f0f4ff !important;
}

.dropdown-item.selected-item {
  background: #e3f2fd !important;
}

.dropdown-item.selected-item .item-title {
  color: #3859D0 !important;
}

/* Item Title */
.item-title {
  font-size: 14px !important;
  color: #333333 !important;
  font-weight: 500 !important;
  line-height: 1.4 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .filter-pill-modern {
    padding: 6px 12px;
    font-size: 13px;
  }
  
  .dropdown-header {
    padding: 10px 14px;
  }
  
  .dropdown-title {
    font-size: 13px;
  }
  
  .dropdown-item {
    padding: 10px 14px !important;
    min-height: 40px !important;
  }
  
  .item-title {
    font-size: 13px !important;
  }
}

/* Animation for dropdown appearance */
.v-overlay__content {
  animation: fadeInUp 0.2s ease-out;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Remove default Vuetify list item styling */
.filter-dropdown-list :deep(.v-list-item__overlay) {
  display: none;
}

.filter-dropdown-list :deep(.v-list-item--active) {
  background: transparent !important;
}

.clear-filters-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
}

.clear-filters-link:hover {
  background: rgba(56, 89, 208, 0.1);
  border-radius: 10px;
}

.filter-by {
  color: #3859D0;
  font-size: 13px;
}

.filter-by:hover {
  color: #3859D0;
  font-size: 13px;
  background: rgba(56, 89, 208, 0.1);
}

.result-badge {
  font-size: 11px;
  padding: 2px 12px;
  color: #646464;
  background: rgba(100, 100, 100, 0.1);
  border-radius: 14px;
}

.search-wrapper {
  min-width: 320px;
  max-width: 380px;
  width: 100%;
  border: 1px solid #C9C9C9;
  border-radius: 13px;
  background: #FFFFFF;
  height: 40px;
}

.pill-search {
  color: #CCCCCC;
  font-size: 13px;
  border-radius: 13px;
}

.pill-search :deep(.v-field__field) {
  align-items: center;
}

.pill-search :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 10px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.search-icon {
  margin-left: 12px;
  margin-top: -4px;
  height: 18px;
}

.modern-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  border-radius: 12px !important;
  padding: 8px 20px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.modern-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
}

.reprocess-btn {
  background: linear-gradient(135deg, #9747ff 0%, #7c3aed 100%) !important;
  color: white !important;
  position: relative;
}

.action-btn {
  text-transform: none !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  flex: 1;
}

.action-btn-dialog {
  text-transform: none !important;
  font-weight: 500 !important;
  border-radius: 8px !important;
  padding: 8px 24px !important;
}

/* Search & Filter Section */
.search-section {
  padding: 1.5rem 2rem 0 2rem !important;
}

.modern-search,
.modern-select {
  border-radius: 12px;
}

.filter-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.result-chip {
  font-weight: 500;
}

.clear-filter-btn {
  text-transform: none !important;
  border-radius: 8px !important;
}

/* Products Grid */
.products-grid {
  padding: 0px !important;
  margin-top: 16px !important;
}

.products-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.9rem;
}

/* Product Cards - ขนาดเล็กลง */
.product-card-modern {
  border-radius: 12px !important;
  border: 1px solid #C9C9C9;
  box-shadow: none !important;
  width: 320px !important;
}

/* .product-card-modern:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
} */

.product-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 8px;
}

.product-image-container {
  position: relative;
  overflow: hidden;
  padding: 0; /* Remove horizontal padding so overlay can span full width */
  margin-top: 8px;
}

.product-image-modern {
  object-fit: cover;
  display: block;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 180px;
  width: 100%;
}

/* .product-card-modern:hover .product-image-modern {
  transform: scale(1.02);
} */

.image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  background: #f5f5f5;
}

.product-content {
  padding: 0px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-grow: 1;
  margin-top: 8px;
}

.product-header-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%; /* Match exactly the image width */
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  background: rgba(0, 0, 0, 0.5);
}

.product-name {
  font-size: 14px;
  font-weight: 600;
  background: linear-gradient(100deg, #F2D1D1 0%, #ffffff 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.product-price {
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
}

.product-category {
  margin: 0;
}

.product-description-modern {
  color: #646464;
  line-height: 1.3;
  font-size: 15px;
}
.group-status-recommend-visible {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 4px;
}
.visible-categories {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 12px;
  margin-top: -8px;
}

.product-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 30px;
  padding: 4px 12px;
  border-radius: 16px;
  box-shadow: 0 -5px 10px -5px rgba(17, 16, 16, 0.06),
    0 5px 10px -5px rgba(23, 23, 23, 0.06);
}

.categories-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 132px;
  height: 30px;
  gap: 12px;
  padding: 4px 12px;
  border-radius: 16px;
  box-shadow: 0 -5px 10px -5px rgba(17, 16, 16, 0.06),
    0 5px 10px -5px rgba(23, 23, 23, 0.06);
}

.status-chip {
  font-size: 0.65rem !important;
}

.product-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: flex-end;
}

.action-btn {
  text-transform: none !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  flex: 1;
  font-size: 0.7rem !important;
  padding: 4px 8px !important;
  min-height: 24px !important;
}

/* Empty States - ลดขนาด */
.empty-state {
  text-align: center;
  padding: 1rem;
  color: #6c757d;
  margin: 140px 0;
}

.empty-title {
  font-size: 15px;
  font-weight: 400;
  margin: 8px 0;
  color: #171717;
}

.empty-subtitle {
  font-size: 0.875rem;
  color: #646464;
}

/* Tablet specific widening (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .product-card-modern.mt-4 { max-width: 100%; }
  .product-image-modern { height: 200px; }
  .product-description-modern { font-size: 14px; }
  .product-actions button img { width:22px; height:22px; }
}

/* Dialog Styles */
/* .modern-dialog {
  z-index: 1000;
}

.modern-dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-bottom: 1px solid rgba(0,0,0,0.08);
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}

.close-btn {
  color: #6c757d !important;
}

.dialog-content {
  padding: 2rem !important;
}

.dialog-actions {
  padding: 1.5rem 2rem !important;
  background: #f8f9fa;
  border-top: 1px solid rgba(0,0,0,0.08);
} */

/* Image Upload */
.image-upload-modern {
  width: 100%;
}

.upload-btn-modern {
  text-transform: none !important;
  border-radius: 12px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.selected-file-modern {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.file-name {
  flex-grow: 1;
  font-size: 0.875rem;
  color: #495057;
  font-weight: 500;
}

/* Switches */
.switches-container {
  display: flex;
  align-items: center;
  height: 56px;
}

.modern-switch {
  margin: 0 !important;
  transform: scale(0.9);
}

/* Image Preview */
.image-preview-container {
  margin-top: 1rem;
}

.preview-title {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
}

.preview-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.preview-image {
  background: #f8f9fa;
}

/* Category Management */
.add-category-section {
  margin-bottom: 1rem;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
}

.empty-categories {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;
}

.empty-text {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 1rem 0 0.5rem 0;
  color: #495057;
}

.empty-subtext {
  font-size: 0.9rem;
  margin: 0;
}

.categories-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.category-item {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.category-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

.category-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
}

.category-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-grow: 1;
}

.category-icon {
  opacity: 0.7;
}

.category-name {
  font-size: 1rem;
  font-weight: 500;
  color: #2c3e50;
}

.edit-input {
  max-width: 200px;
}

.category-actions {
  display: flex;
  gap: 0.25rem;
}

/* Loading Overlay */
/* .loading-card {
  background: white;
  border-radius: 16px !important;
  padding: 2rem;
  text-align: center;
  min-width: 300px;
}

.loading-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
}

.loading-subtitle {
  color: #6c757d;
  margin: 0;
} */

/* Notification Badge */
.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #ff4757;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
  border: 2px solid white;
  animation: pulse 2s infinite;
}

/* Animations */
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px rgba(255, 71, 87, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
  }
}

/* Focus and Accessibility */
.modern-btn:focus,
.action-btn:focus,
.action-btn-dialog:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

@media screen and (min-width: 250px) and (max-width: 479px) {
  .card-title {
    font-size: 14px;
    font-weight: 600;
  }
  .minimal-field {
    width: 80%;
  }
  .products-title {
    display: flex;
    flex-direction: column;
  }
  .products-header-right {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
  }
  .products-header-button {
    width: 100%;
  }
  .products-searchCathFilter {
    flex-direction: column;
    align-items: center;
  }
  .filter-left {
    flex-direction: column;
  }
  .filter-right {
    display: flex;  
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
  .search-wrapper {
    min-width: 200px;
    max-width: 260px;
  }
  .visible-categories {
    flex-direction: column;
    align-items: center;
  }
  .group-status-recommend-visible {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
}

@media screen and (min-width: 480px) and (max-width: 767px) {
  .products-title {
    display: flex;
    flex-direction: column;
  }
  .products-header-right {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
  }
  .products-header-button {
    width: 100%;
  }
  .products-searchCathFilter {
    flex-direction: column;
    align-items: center;
  }
  .filter-left {
    flex-direction: column;
  }
  .filter-right {
    display: flex;  
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .products-title {
    display: flex;
    flex-direction: column;
  }
  .products-header-right {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
  }
  .products-header-button {
    width: 100%;
  }
  .products-searchCathFilter {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  .filter-left {
    flex-direction: column;
  }
  .filter-right {
    display: flex;  
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
  .visible-categories {
    flex-direction: column;
    align-items: center;
  }
  .group-status-recommend-visible {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
}

.delet-btn:disabled {
  border: 1px solid #dd00004d !important;
  color: #dd000085 !important;
}

.delet-btn:disabled :deep(.v-icon) {
  color: #dd00007b !important;
  opacity: 1 !important;
}
/* --- Product Dialog Redesign --- */
.product-dialog-card { background:#fff; border-radius:12px; border:1px solid #f0f2f5; box-shadow:0 4px 20px -4px rgba(0,0,0,0.08); display:flex; flex-direction:column; }
.product-dialog-header { display:flex; justify-content:space-between; align-items:center; padding: 10px 0; }
.product-dialog-title { font-size:16px; font-weight:600; color:#171717; margin-left: 24px; }
.product-dialog-close { background:transparent; border:none; cursor:pointer; width:34px; height:34px; border-radius:8px; display:flex; align-items:center; justify-content:center; }
/* .product-dialog-close:hover { background:#f5f5f5; } */
.product-dialog-body { padding:0 22px 10px 22px; }
.form-row {
  display:flex;
  justify-content: space-between;
  gap:14px;
  width: 100%;
}
.form-field { flex:1; display:flex; flex-direction:column; }
.form-field.half { flex:1; }
.pill-input, .pill-select { width:100%; color: #171717; background:#ffffff; border:1px solid #c9c9c9; border-radius:10px; padding:10px 14px; font-size:14px; outline:none; transition:border-color .15s, background .15s; }
/* .pill-input:hover {
  color: #cccccc;
} */
/* Keep selected category text color; don't override to grey on hover */
.pill-select:hover {
  color: inherit;
}
.pill-input:focus, .pill-select:focus { background:#ffffff; border: 1px solid #3859D0; }
.pill-select { appearance:none; -webkit-appearance:none; position:relative; }
.pill-select:after { content:'▼'; position:absolute; right:14px; top:50%; transform:translateY(-50%); font-size:10px; color:#666; }
/* Custom category select styling */
.category-select-wrapper { position:relative; width:100%; }
.category-select { padding-right:34px; color:#cccccc; font-size:13px; }
.category-select option[disabled] { color:#cccccc; }
.select-arrow-icon { position:absolute; right:14px; top:50%; transform:translateY(-50%); width:14px; height:14px; pointer-events:none; }
/* When a real option is selected (non-null), show dark text */
.category-select.has-selection { color:#171717; }
.upload-box {
  border:1px dashed #949AA8;
  background: linear-gradient(100deg, #FFF2F2 0%, #FFFFFF 100%) !important;
  border-radius: 8px;
  padding:26px 20px;
  cursor:pointer;
  text-align:center;
}
.upload-box:hover {
  border: 1px dashed #3859D0;
  background: linear-gradient(100deg, #F2D1D1 0%, #FFFFFF 100%) !important;
}
.upload-inner { display:flex; flex-direction:column; gap:8px; align-items:center; }
.upload-btn-core {
  background:#ffffff;
  border:1px solid #C32E0E;
  color:#C32E0E;
  border-radius:12px;
  padding:8px 26px;
  font-size:13px;
  font-weight:500;
  cursor:pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}
.upload-btn-core:hover {
  background:#FDE4DF;
  color:#C32E0E;
}
.upload-hint {
  font-size: 11px;
  color:#646464;
}
.upload-file-name {
  max-width:100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.uploaded-file {
  display: flex;
  flex-direction: column;
}
.product-image-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  border: 1px solid #C9C9C9;
  border-radius: 8px;
  width: 170px;
  height: 170px;
  margin-left: 36px;
  margin-top: 4px;
}
.product-preview-img {
  padding: 6px;
  width: 160px;
  height: 160px;
}
.uploaded-name-delete {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.file-name-rectangle {
  width:240px;
  height:32px;
  background:url('@/assets/Rectangle1 (1).png') center/cover no-repeat;
  display:flex;
  align-items:center;
  border-radius:6px;
  padding:0 8px;
  overflow:hidden;
}
.file-name-text {
  font-size:11px;
  font-weight:500;
  color:#171717;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.checkbox-row { display:flex; gap:24px; padding:4px 4px 0 4px; }
.checkbox-label { font-size:10px; color:#646464; display:flex; align-items:center; gap:6px; }
.checkbox-label input { width:16px; height:16px; cursor:pointer; }
.pill-textarea {
  width: 100%;
  background: #ffffff;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 12px;
  min-height: 140px;
  resize: vertical;
  outline: none;
  color: #171717;
}
.pill-textarea::placeholder {
  color: #CCCCCC;
}
/* .pill-textarea:focus { background:#fff; border-color:#ff7a45; } */
.product-dialog-footer { display:flex; justify-content:flex-end; gap:10px; padding:12px 22px 20px 22px; }
.product-dialog-footer .footer-btn { border:none; border-radius:12px; padding:10px 26px; font-size:13px; font-weight:500; cursor:pointer; letter-spacing:.3px; transition:background .15s, box-shadow .2s; }
.product-dialog-footer .footer-btn.cancel { background:#f5f5f7; color:#555; border: 1px solid #949AA8;}
.product-dialog-footer .footer-btn.cancel:hover { background:#ebebef; }
.product-dialog-footer .footer-btn.save { background:#ff6236; color:#fff; box-shadow:0 4px 14px -3px rgba(255,98,54,0.55); }
.product-dialog-footer .footer-btn.save:hover { background:#ff6f47; }

.footer-btn[data-v-95e08fb6] {
  border-radius: 10px;
}
/* Price & Category row layout */
.price-category-row { justify-content:space-between; }
/* Price input prefix & icon */
.input-with-icon { position:relative; display:flex; align-items:center; }
.input-icon { position:absolute; right:12px; width:22px; height:22px; opacity:.8; }
/* Currency prefix styling */
.input-prefix { position:absolute; left:14px; font-size:13px; color:#171717; font-weight:500; }
.pill-input.has-prefix { padding-left:32px !important; color:#171717; }
/* Hide price select down buttons */
input[type=number].pill-input::-webkit-inner-spin-button,
input[type=number].pill-input::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
input[type=number].pill-input { -moz-appearance: textfield; appearance: textfield; }
/* Hide price select down buttons */
/* --- End Product Dialog Redesign --- */
/* Validation Dialog Styles */
.validation-card {
  border-radius: 12px !important;
  overflow:hidden;
}
.validation-header { 
  background: linear-gradient(900deg,#FFF8ED, #FFF0DA);
  padding: 10px 0px;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.validation-title { 
  font-size:13px;
  font-weight:600;
  color:#FFA726;
  letter-spacing:.3px;
  margin-left: 16px;
}
.validation-close { background:transparent; border:none; cursor:pointer; font-size:16px; color:#555; width:32px; height:32px; display:flex; align-items:center; justify-content:center; border-radius:8px; }
.validation-close:hover { background:#f5f5f5; }
.validation-body {
  padding: 16px;
}
.validation-message {
  font-weight: 500;
  font-size:13px;
  color:#171717;
}
.validation-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.validation-ok-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #ffffff !important;
  width: 104px;
  background: #FFA726;
}

.category-dialog-card {
  background: #ffffff;
  border-radius: 4px;
  padding: 0;
  box-shadow: 0 4px 24px -4px rgba(0,0,0,0.08);
  border: 1px solid #f0f2f5;
  display: flex;
  flex-direction: column;
}

.category-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  margin: 8px 0;
}
.category-dialog-title {
  font-size: 15px;
  font-weight: 600;
  color: #171717;
  letter-spacing: .3px;
}
.category-dialog-close {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #666;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display:flex;
  align-items:center;
  justify-content:center;
  transition: background .15s;
}

.category-dialog-body { padding: 0 22px 12px 22px; }

.category-add-row {
  display:flex;
  gap:10px;
  align-items:center;
  margin-top:4px;
}
.category-input-wrapper {
  position: relative;
  flex:1;
  display:flex;
  align-items:center;
}
.category-input-pill {
  flex:1;
  background:#ffffff;
  border:1px solid #c9c9c9;
  border-radius: 10px;
  padding:10px 16px;
  font-size:14px;
  outline:none;
}
.category-inline-add-btn {
  position:absolute;
  right:6px;
  top:50%;
  transform:translateY(-50%);
  background:#FEE3E3;
  border:none;
  width:26px;
  height:26px;
  border-radius:9999px;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  padding:0;
  transition: background .15s;
}
.category-add-btn:hover { background:#ff8f62; }
.category-add-btn:disabled { background:#ff7a4545; cursor:not-allowed; box-shadow:none; }

.category-list-wrapper { margin-top:18px; }
.category-list-title {
  font-size:13px;
  font-weight:600;
  color:#555;
  margin-bottom:8px;
}
.category-empty {
  padding:14px;
  background:#ffffff;
}

.category-ul { list-style:none; margin:0; padding:0; display:flex; flex-direction:column; gap:6px; }
.category-li {
  background:#fff;
  border:1px solid #edf0f3;
  border-radius: 14px;
  padding:10px 14px 10px 16px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  transition: border-color .15s, box-shadow .15s;
  box-shadow: 0 -2px 4px -2px rgba(0, 0, 0, 0.08),
              0 2px 4px -2px rgba(0, 0, 0, 0.08);
  margin-top: 8px;
}
/* .category-li:hover { border-color:#d7dadf; box-shadow:0 2px 10px -2px rgba(0, 0, 0, 0.06) } */

.category-name-wrap { flex:1; min-width:0; }
.category-static-name {
  font-size: 15px;
  color:#171717;
  font-weight: 400;
}
.category-edit-input {
  width:100%;
  background:#ffffff;
  font-size:15px;
  font-weight: 400;
  outline:none; }

.category-row-actions {
  display:flex;
  align-items:center;
  gap:10px;
}
.row-action-btn {
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
}
/* .row-action-btn.edit:hover { background:#fff3e6; border-color:#ffbc85; } */
/* .row-action-btn.confirm { background:#e6fff1; border-color:#b6f5ce; } */
/* .row-action-btn.confirm:hover { background:#d9ffe9; } */
/* .row-action-btn.delete:hover { background:#ffecec; border-color:#ffb3b3; } */
/* .row-action-btn:active { transform: translateY(1px); } */

.action-icon { pointer-events:none; }

.category-dialog-footer {
  display:flex;
  align-items: center;
  justify-content:flex-end;
  gap:10px;
  padding:12px 22px 20px 22px;
}
.footer-btn {
  border-radius: 16px;
  padding:10px;
  font-size:13px;
  font-weight:500;
  cursor:pointer;
}
.footer-btn.cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  border:1px solid #949AA8;
  background:#ffffff;
  color:#646464;
}
.footer-btn.cancel:hover { 
  background:#ebebef;
}
.footer-btn.save {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 8px;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  width: 140px;
}
.footer-btn.save span {
  color: #FFFFFF;
}

.category-select option { color:#171717; }
.category-select option:disabled, .category-select .placeholder-option { color:#cccccc !important; }
</style>
